import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { FiX, FiSearch } from "react-icons/fi";
import SellerSearch from "./SellerSearch";

// "Find Seller": a window with the seller search and its filters, opened from the Co-Work banner button
// and from the buyer's sidebar. Buyers search here and message the seller they like.
export default function SellerSearchModal({ settings, onClose, onMessage }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [onClose]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-start sm:items-center justify-center p-3 sm:p-6"
      onClick={onClose}
    >
      <motion.div
        role="dialog"
        aria-modal="true"
        aria-label="Find a seller"
        initial={{ opacity: 0, scale: 0.97, y: 12 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.2 }}
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-5xl max-h-full flex flex-col bg-navy text-white border border-navy-border rounded-2xl shadow-2xl overflow-hidden"
      >
        <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-96 h-48 rounded-full bg-accent/25 blur-[90px] pointer-events-none" />

        <div className="relative flex items-start justify-between gap-4 px-6 pt-6 pb-4 border-b border-navy-border">
          <div className="flex items-center gap-3">
            <span className="w-11 h-11 rounded-xl bg-accent/15 text-accent-light flex items-center justify-center"><FiSearch size={20} /></span>
            <div>
              <h2 className="text-2xl font-bold leading-tight">{settings?.sellers_heading || "Find a Seller"}</h2>
              <p className="text-sm text-gray-400">{settings?.sellers_intro}</p>
            </div>
          </div>
          <button onClick={onClose} aria-label="Close" className="text-gray-400 hover:text-white shrink-0"><FiX size={22} /></button>
        </div>

        <div className="relative overflow-y-auto px-6 py-5">
          <SellerSearch settings={settings} onMessage={onMessage} />
        </div>
      </motion.div>
    </motion.div>
  );
}
